import { render, staticRenderFns } from "./TumoralPhenomenaSection.vue?vue&type=template&id=ec592b68&"
import script from "./TumoralPhenomenaSection.vue?vue&type=script&lang=js&"
export * from "./TumoralPhenomenaSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports